module.exports = __webpack_public_path__ + "static/ogp-blog-69287d69a651c2eadf5994e194145d08.png";